import { BOOKING_STEPS } from "../lib/brand";
import { useReveal } from "../hooks/useReveal";

export const HowToBook = () => {
  const headRef = useReveal();
  const stepsRef = useReveal();

  return (
    <section
      id="book"
      data-testid="howtobook-section"
      className="py-24 md:py-40 border-b border-black/100"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div ref={headRef} className="reveal flex items-end justify-between gap-8 mb-12 md:mb-16">
          <div>
            <div className="label-eyebrow mb-4">How to book</div>
            <h2 className="font-display text-[2.6rem] md:text-7xl leading-[0.95] tracking-[-0.015em]">
              Four quiet <span className="italic">steps.</span>
            </h2>
          </div>
          <span className="label-eyebrow hidden md:block opacity-60">Vol. IV</span>
        </div>

        <div
          ref={stepsRef}
          className="reveal reveal-delay-2 grid grid-cols-1 md:grid-cols-4 gap-0 border-t border-b border-black"
        >
          {BOOKING_STEPS.map((step, i) => (
            <div
              key={step.n}
              data-testid={`booking-step-${i}`}
              className={`group p-8 md:p-10 flex flex-col gap-8 ${
                i !== BOOKING_STEPS.length - 1 ? "md:border-r border-black" : ""
              } ${i !== 0 ? "border-t md:border-t-0 border-black" : ""}
              transition-colors duration-500 hover:bg-black hover:text-white`}
            >
              <div className="font-display text-7xl md:text-8xl tracking-tight leading-none">
                {step.n}
              </div>
              <p className="font-body text-[15px] leading-[1.75] max-w-xs">
                {step.text}
              </p>
              <span className="label-micro mt-auto opacity-60 group-hover:opacity-100 transition-opacity">
                Step {step.n}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-6">
          <p className="font-body text-sm text-black/70 max-w-md leading-relaxed">
            Once submitted, we confirm availability and share a pickup plan
            within the day. For anything urgent — just call us.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#contact" data-testid="book-cta-contact" className="btn-pill btn-pill-solid">
              Start my booking
            </a>
            <a href="#terms" data-testid="book-cta-terms" className="label-micro link-underline">
              Read terms &amp; conditions →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
